import { useQuery } from '@tanstack/react-query';
import { getCategoriesReq } from '../api';
import { useDispatch } from 'react-redux';
import { setCategories } from '../../redux/categories.slice';
import { toast } from 'react-toastify';
import Notification from '../../components/Notification';

export const useCategoriesQuery = () => {
    const dispatch = useDispatch();
    const { isLoading } = useQuery({
        queryKey: ['categories'],
        queryFn: async () => {
            try {
                const token = localStorage.getItem('assessmentai-token');

                if (!token) {
                    throw { token: false };
                }
                const response = await getCategoriesReq();
                dispatch(setCategories(response?.data));
                return response;
            } catch (error) {
                // toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
                console.error('Error fetching categories:', error);
                throw error;
            }
        },
        retry: false,
        refetchOnWindowFocus: false,
    });

    return { isLoading };
};
